import React from 'react';
import { connect } from 'react-redux';
// Grid imports
/*
    Using sortable hoc by clauderic to create the level item grid. 

    For more information and help, see:
    https://github.com/clauderic/react-sortable-hoc
*/
import { sortableElement } from 'react-sortable-hoc';
// Popup imports
import { OpenPopup } from '../../../actions/popupActions';
import { PopupTypes, PopupStates } from '../../Popup/Enums';
import LevelSettingsModeEnum from '../../Popup/Types/LevelSettings/enums';
// Game(kit) imports
import gameKit from '../../../../GameKit';
import settings from '../../../../settings';
import { levelSettings } from '../../../../GameKit/shared';

const GridLevelItem = sortableElement(({ levelNumber, thumbnail, description, onSettings, onEdit, onTest, onCopy, onDelete }) => {
    let style = {};
    if (thumbnail !== undefined) {
        style = {
            backgroundImage: `url(${thumbnail})`
        };
    }

    const descriptionContent = description !== levelSettings.description && description.trim().length > 0 ? description : 'klik op het tandwiel om de levelopdracht van dit level te schrijven';

    return (
        <div className="level-item">
            <div className="level-item-content">
                <div className="level-number">
                    LEVEL
                    <span>{levelNumber}</span>
                </div>
                <div className="thumbnail-desc">
                    <div className="thumbnail-container" style={style}>
                        {thumbnail === undefined ? <img src={`${settings.assetsPath}img/icons/camera.png`} alt="Camera" /> : <></>}
                    </div>
                    <span>{descriptionContent}</span>
                </div>
                <div className="buttons-container">
                    <button className="btn-edit" type="button" onClick={onEdit} title="Bouw level">
                        bouw
                    </button>
                    <button className="btn-test" type="button" onClick={onTest} title="Test level">
                        test
                    </button>
                </div>
                <div className="icons-container">
                    <button className="btn-remove" type="button" onClick={onDelete} title="Verwijder level" />
                    <button className="btn-copy" type="button" onClick={onCopy} title="Kopieer level" />
                    <button className="btn-settings" type="button" onClick={onSettings} title="Level instellingen" />
                </div>
            </div>
        </div>
    );
});

class LevelItem extends React.Component {
    onSettings = () => {
        const { dispatch, uuid } = this.props;
        dispatch(
            OpenPopup(PopupTypes.LEVEL_SETTINGS, PopupStates.DEFAULT, {
                mode: LevelSettingsModeEnum.MAIN,
                fromLevelGrid: true,
                levelUuid: uuid
            })
        );
    };

    onEdit = () => {
        const { uuid } = this.props;
        gameKit.openLevel(uuid);
        gameKit.game.requestNewVisuals();
    };

    onTest = () => {
        const { uuid } = this.props;
        gameKit.openLevel(uuid);
        gameKit.levelEditor.startTest();
    };

    onCopy = () => {
        const { uuid } = this.props;
        gameKit.copyLevel(uuid);
    };

    onDeleteClick = () => {
        const { dispatch } = this.props;
        dispatch(
            OpenPopup(PopupTypes.LEVEL_REMOVE_WARNING, PopupStates.DEFAULT, {
                onRemove: this.onDelete
            })
        );
    };

    onDelete = () => {
        const { uuid } = this.props;
        gameKit.deleteLevel(uuid);
    };

    render() {
        const { index, thumbnail, description } = this.props;

        return (
            <GridLevelItem
                index={index}
                levelNumber={index + 1}
                thumbnail={thumbnail}
                description={description}
                onSettings={this.onSettings}
                onEdit={this.onEdit}
                onTest={this.onTest}
                onCopy={this.onCopy}
                onDelete={this.onDeleteClick}
            />
        );
    }
}

LevelItem.defaultProps = {};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelItem);
